import React, { Component } from "react";

import { Button, Box, Card, CardBody, Text } from '@chakra-ui/react';

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

import BoolCellTrueOnlyRenderer from "../../../components/lib/agGridRenderers/BoolCellTrueOnlyRenderer";
import { dateTimeFormatter } from "../../../components/lib/agGridRenderers/agGridFormatters";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt, faRedoAlt } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from 'react-tooltip';

import CoreService from "../../../services/CoreService";


/*
const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";
*/


const columnDefs = [
    { headerName: "Logged Time", field: "recordedDateTime", sortable: true, filter: true, resizable: true, maxWidth: 200 },
    { headerName: "Status", field: "resultStatus", sortable: true, filter: true, resizable: true, maxWidth: 100 },
    { headerName: "Successful", field: "successful", sortable: true, filter: true, resizable: true, maxWidth: 110, cellRendererFramework: BoolCellTrueOnlyRenderer },
    { headerName: "Any Posted?", field: "didPostEvents", sortable: true, filter: true, resizable: true, maxWidth: 110, cellRendererFramework: BoolCellTrueOnlyRenderer },
    { headerName: "Elapsed Seconds", field: "pollingElapsedSeconds", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 180 },
    { headerName: "Total Polled", field: "totalItemsPolled", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 180 },
    { headerName: "Throttle Size", field: "pollingThrottleSize", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 180 },
    { headerName: "Total Posted", field: "totalItemsPosted", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 180 },
    { headerName: "Total Filtered", field: "totalItemsFilteredOut", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 180 },
    { headerName: "Total Failed", field: "totalItemsFailed", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 180 },
    { headerName: "Started", field: "pollingStartDateTime", sortable: true, filter: true, resizable: true, maxWidth: 200 },
    { headerName: "Ended", field: "pollingEndDateTime", sortable: true, filter: true, resizable: true, maxWidth: 200 },
    { headerName: "Id", field: "transactionId", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 180 }
];



export default class TelemetryLogGrid extends Component {
    constructor(props) {
        super(props);
        this.coreService = new CoreService();
        this.state = {
            gridSchema: [],
            schema: null,
            gridData: [],
            isLoading: true,
            selectedRow: null
        }
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.requestGridDataRefresh = this.requestGridDataRefresh.bind(this);
    }

    async componentDidMount() 
    {
        if (this.props.isConnected) {
            if (!this.auth.loggedIn()) {
                this.props.onSystemLogoutRequest();
            }
        }
        await this.refreshGridData();
    }


    async refreshGridData() {
        this.setState({ isLoading: true });
        var gridDataResponse = await this.coreService.fetchTelemetryEventList(this.props.userSession.gcid, this.props.userSession.token);
        // TBD deal with error
        var newGridData = gridDataResponse.dataResult;
        this.setState({
            gridData: newGridData,
            isLoading: false
        });
    }

    onSelectionChanged() {
        var selectedNodes = this.gridApi.getSelectedNodes();
        var rowData = selectedNodes[0].data;
        this.setState({ selectedRow: rowData });
        console.log("RowData: ");
        console.info(rowData);
        this.props.onRowSelected(rowData);
    }

    onEditGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridColumnApi.applyColumnState({
            state: [
                {
                    colId: 'recordedDateTime',
                    sort: 'desc'
                }
            ]
        });
        this.gridApi.sizeColumnsToFit(params);
    };

    async requestGridDataRefresh(e) {
        await this.refreshGridData();
        this.props.onToastRequest("information", "Telemetry List Refreshed");
    }


    render() {

        const divStyle = {
            width: "100%",
            height: "500px",
        };

        const gridData = (this.state.gridData) ? this.state.gridData : [{}];
        const loadingIcon = this.state.isLoading ? (
            <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
        ) : (
            ""
        );

        return (
            <Box bgColor="white">
                <Tooltip />

                    <Text style={{ textAlign: "left", marginTop: "5px", marginLeft: "10px", fontSize: '20px' }}>Telemetry Event List</Text>
  
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <p data-tip="Refresh List">
                                <Button size="sm"   onClick={(e) => this.requestGridDataRefresh(e)}>
                                    <FontAwesomeIcon icon={faRedoAlt} />
                                    &nbsp;&nbsp;Refresh List
                                </Button>
                            </p>
                  

                            <span style={{ marginLeft: "20vw" }}>{loadingIcon}</span>
                        </div>

                        <div className="ag-theme-balham" style={divStyle}>
                            <AgGridReact
                                alwaysShowVerticalScroll
                                rowSelection="single"
                                enableRangeSelection={false}
                                pagination={true}
                                columnDefs={columnDefs}
                                rowData={gridData}
                                animateRows={true}
                                onGridReady={this.onGridReady}
                                onRowSelected={this.onSelectionChanged}
                                // domLayout="autoHeight"
                            />
                        </div>
     


            </Box>
        );
    }
}